module.exports = __webpack_public_path__ + "img/1104.3d8f85e4.jpg";